import React, { useMemo } from 'react';

// LOCAL Components
import Input from '../../../parts/Input';

// MAIN COMPONENT
const Plaintext = ({
  selectedOptions,
  ...props
}) =>  {

  // MEMOS
  const value = useMemo(
    () => Array.isArray(selectedOptions) ? selectedOptions.map(({ label }) => label).join(', ') : '',
    [selectedOptions]
  )

  // RENDER
  return (
    <Input
      value={value}
      plaintext
      {...props}
    />
  )
}

export default Plaintext
